<template>
  <section class="relative py-6 lg:py-8">
    <div class="z-0 w-full h-full absolute inset-0 object-cover bg-gradient-to-r from-blue-400 to-blue-500"/>
    <div
        class="z-10 relative container px-6 mx-auto flex flex-col md:flex-row items-start md:items-center justify-between">

      <h4 tabindex="0" class="focus:outline-none text-2xl font-bold leading-tight text-white">{{ title }}</h4>
      <ul class="flex items-center text-gray-300 text-sm mt-3">
        <li v-for="(link, index) in links" :key="link" class="flex items-center space-x-1.5 mr-2 font-normal">
          <template v-if="index==links.length-1">
            <span class="text-white font-semibold">{{ link.title }}</span>
          </template>
          <template v-else>
            <router-link class="hover:text-white text-gray-200 font-semibold" :to="link.url">{{ link.title }}</router-link>
            <i class="text-lg text-gray-200 fa fa-angle-right"></i>
          </template>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "PageHeader",
  props: {title: String, links: Object}
}
</script>

<style scoped>

</style>
